'use strict';
var CustomScroll = require('./dist/reactCustomScroll');

module.exports = CustomScroll;


//////////////////
// WEBPACK FOOTER
// ./~/react-custom-scroll/index.js
// module id = 1748
// module chunks = 2